<template>
  <zt-modal
        :active="linkUsersModalActive"
        @close="closeModal"
        max-width="42rem"
        :z-index="200"
        :fullscreen="isMobile"
      >
        <template slot="modal-header">
          <div class="p-4 font-normal text-zt-lg text-center md:text-left">
            {{ $t('message.linkUser.linkAccountModal.modalTitle') }}
          </div>
        </template>
        <div class="p-10 text-center md:flex md:text-left">
          <div class="md:w-1/4">
            <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem'}"></zt-icon>
          </div>
          <div class="md:w-3/4">
            <h1 class="text-bold text-xl mb-4  md:mb-3">
              {{ $t('message.linkUser.linkAccountModal.title', {linkUserCount: linkUserCount}) }}
            </h1>
            <div class="text-left">
              <p class=" text-zt-dark-500">{{ $t('message.linkUser.linkAccountModal.description') }}</p>
            </div>
          </div>
        </div>
        <div
          class="zt-modal-footer grey-background border-b flex justify-between p-5 fixed md:relative bottom-0 right-0 left-0"
        >
          <div class="">
            <zt-button
              data-vs-button="active-step"
              class="ml-1 w-11/12"
              color="disabled" style="color: #707070 !important"
              @click="notifyLater()"
              >{{ $t('message.linkUser.linkAccountModal.cancelButton') }}</zt-button
            >
          </div>
          <div class="">
            <zt-button
              data-vs-button="active-step"
              class="ml-1 w-11/12"
              @click="goToLinkUserAccounts()"
              >{{ $t('message.linkUser.linkAccountModal.successOkBtn') }}</zt-button
            >
          </div>
        </div>
      </zt-modal>
    
  </template>

  <script>
  export default {
    props: {
      linkUsersModalActive: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        
      }
    },
    created() {
    if (this.$router.currentRoute.name === 'LinkUser') {
      this.linkUsersModalActive = false
      this.$emit('update:linkUsersModalActive', false); 
    }
  },
    methods: {
      goToLinkUserAccounts() {
        this.closeModal()
        if (this.$router.currentRoute.name !== 'LinkUser') {
          this.$router.push({ name: 'LinkUser' })
        }
      },
      closeModal() {
        this.$emit('update:linkUsersModalActive', false);
      },
      notifyLater() {
        this.$emit('notifyLater')
      }
      
    }
}
</script>
<style scoped>
.grey-background {
  background-color:#ebebeb;
}
</style>